
import React, { FC, MouseEventHandler, useEffect, useState } from 'react';
import './Alert.css';
import { FeedBackType, __, IoCloseCircle, DEFAULT_ANIMATION_DURATION, AlertData, FeedBackConfig } from '@/Shared';

/**
 * AlertProps interface
 *
 * Defines the props for the Alert component.
 */
interface AlertProps {
	/** Alert data containing message, type, and optional duration */
	data?: AlertData | null;

	/** Callback triggered when the alert is dismissed */
	onClose?: () => void;

	/** Determines if the alert can be closed manually by the user */
	dismissible?: boolean;
}

const Alert: FC<AlertProps> = ({ data, onClose, dismissible = true }) => {

	const [innerData, setInnerData] = useState<AlertData | null>();
	const [fadeOut, setFadeOut] = useState("");

	useEffect(() => {
		setFadeOut("");
		setInnerData(data);
	}, [data]);

	// Do not render if no data is provided
	if (!innerData) {
		return null;
	}


	const animateClose = (event : React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		event.preventDefault();
		event.stopPropagation();
		setFadeOut('fade-out');
		setTimeout(() => {
			onClose?.();
			setInnerData(null);
		},
			DEFAULT_ANIMATION_DURATION
		);
	}
	const type = innerData.type ?? FeedBackType.INFO;

	return (
		<div className={`Alert feedback feedback--${type} ${fadeOut}`}
			role="alert"
			aria-live="assertive"
			tabIndex={-1}>
			<div className="Alert__header ">
				<span className="Alert__icon">{FeedBackConfig[type].icon}</span>
				<strong className="Alert__title">{innerData.title ?? FeedBackConfig[type].title}</strong>
				{
					dismissible && (
						<button 
						type="button" 
						className="custom-close-btn" onClick={(event) => animateClose(event)} 
						aria-label="Close alert">
							<IoCloseCircle />
						</button>
					)}
			</div>
			<div className="divider"></div>
			<div className="Alert__body">
				{(typeof innerData.message === 'string') ? __(innerData.message) : innerData.message}
			</div>
		</div>
	);
};


export default Alert;
